var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenmoPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 35,
    viewBox: "0 0 52 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 34,
    rx: 7.5,
    fill: "#3D95CE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 34,
    rx: 7.5,
    stroke: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9168 14C12.2009 14.4692 12.329 14.9524 12.329 15.5628C12.329 17.5097 10.6667 20.0389 9.3175 21.8149H6.2359L5 14.4263L7.69828 14.1701L8.35171 19.4276C8.96227 18.4332 9.7157 16.8704 9.7157 15.8049C9.7157 15.2216 9.61578 14.8244 9.45959 14.4973L11.9168 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.414 17.254C15.9105 17.254 17.1606 17.0269 17.1606 16.3165C17.1606 15.9755 16.9193 15.8053 16.6351 15.8053C16.1377 15.8053 15.4851 16.4016 15.414 17.254ZM15.3571 18.6608C15.3571 19.5282 15.8395 19.8685 16.479 19.8685C17.1754 19.8685 17.8421 19.6983 18.7088 19.258L18.3824 21.4741C17.7717 21.7724 16.8201 21.9715 15.8964 21.9715C13.5534 21.9715 12.7148 20.5508 12.7148 18.7747C12.7148 16.4728 14.0789 14.0285 16.8911 14.0285C18.4394 14.0285 19.3052 14.8958 19.3052 16.1034C19.3053 18.0503 16.8061 18.6467 15.3571 18.6608Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0922 15.7056C27.0922 15.9897 27.0492 16.4019 27.0062 16.6712L26.1966 21.7866H23.5692L24.3078 17.0974C24.3218 16.9702 24.3648 16.7142 24.3648 16.5721C24.3648 16.231 24.1517 16.1459 23.8954 16.1459C23.5551 16.1459 23.2139 16.302 22.9867 16.416L22.149 21.7867H19.5068L20.7139 14.128H23.0007L23.0296 14.7393C23.5691 14.3841 24.2796 14 25.2875 14C26.6229 13.9999 27.0922 14.6821 27.0922 15.7056Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8924 14.8669C35.6449 14.3275 36.3555 14.0285 37.3351 14.0285C38.6841 14.0285 39.1534 14.7108 39.1534 15.7343C39.1534 16.0184 39.1104 16.4305 39.0676 16.6999L38.2588 21.8153H35.6307L36.3835 17.027C36.3973 16.899 36.4265 16.7428 36.4265 16.6438C36.4265 16.2597 36.2132 16.1746 35.957 16.1746C35.6307 16.1746 35.3045 16.3166 35.0622 16.4447L34.2246 21.8154H31.5973L32.3499 17.027C32.3637 16.899 32.3921 16.7429 32.3921 16.6439C32.3921 16.2598 32.1786 16.1746 31.9234 16.1746C31.5823 16.1746 31.2418 16.3308 31.0146 16.4448L30.1762 21.8155H27.5349L28.7419 14.1567H31.0008L31.0718 14.7961C31.5973 14.4129 32.3071 14.0288 33.2586 14.0288C34.0826 14.0285 34.6219 14.3838 34.8924 14.8669Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3817 17.0977C44.3817 16.4725 44.2252 16.0463 43.7569 16.0463C42.7201 16.0463 42.5071 17.879 42.5071 18.8166C42.5071 19.5279 42.7061 19.9681 43.1744 19.9681C44.1544 19.9681 44.3817 18.0352 44.3817 17.0977ZM39.837 18.7034C39.837 16.2882 41.115 14.0283 44.0554 14.0283C46.271 14.0283 47.081 15.3358 47.081 17.1406C47.081 19.5278 45.8168 22 42.8053 22C40.5755 22 39.837 20.5363 39.837 18.7034Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmoPreview);
export default __webpack_public_path__ + "static/media/VenmoPreview.2621f49d55896cf273cba5fe64c3b20a.svg";
export { ForwardRef as ReactComponent };